import Modal from './modal.js';

$(document).ready(function() {

    //remove initial arrow
    $('th.select-checkbox').removeClass('sorting_desc');

     $('.bulk-action').change(function() {
       var actionVal = $(this).val();
         $('.bulk-action-text-info').html("");

       var route = '/visit/destroy/bulk';
       var signOut = false;
       var bulkActionText = 'Are you sure you want to delete these visits?';

       if(actionVal === 'sign-out'){
         route = '/visit/end/bulk';
         signOut = true;
         bulkActionText = 'Are you sure you want to sign out these visits?';
       }

       var ids = getCheckedVisitIds(signOut);

        Modal.openModal('.bulk-action-modal');

        $('.bulk-action-text').html(bulkActionText);

       $('.bulk-action-modal .close-site-modal').click(function() {
           $('.bulk-action').val('null');
       });


         // If modal accepted close modal and fire request
         $('.bulk-action-accept').click(function() {
             //fire off api request

             if(ids.length > 0) {
                 $(this).html('Working...');
                 doAction(route,ids);
             }

         });

    });



    function getCheckedVisitIds(signOut){

        var visitIds = [];
        var error = "";
    
         $("tr.selected").each(function() {

            if($(this).attr('data-is-scheduled') === "1" && signOut){

                error = "<p>One or more of the visits selected is scheduled so they will not be signed out</p>";
                
            }else{
                //add the visit id
                visitIds.push($(this).attr('data-visit-id'));
            }

            
        });

         if(error) {
            $('.bulk-action-text-info').html(error);
         }

        return visitIds;
    }

    function showAlert(endRoute) {
        $('.alert').show();
        setTimeout(function() {
            $('.alert').addClass('alert--active');
            $('.quick-add-visit-icon').addClass('quick-add-visit-icon--active');

            setTimeout(function() {
                $('.alert').removeClass('alert--active');
                $('.quick-add-visit-icon').removeClass('quick-add-visit-icon--active');

                //reload page if ending visits
                if(endRoute){
                    location.reload();
                }

            }, 3500)
        }, 500);

    }

    function completeCallback(route,ids, signOutErrorMessage = '') {
        var table = $('.data-table').DataTable();
        var endRoute = true;

        if( route !== '/visit/end/bulk') {
            endRoute = false;

            for(var i=0; i < ids.length; i++) {

                var rows = table
                    .rows( $('tr[data-visit-id="' + ids[i] + '"') )
                    .remove()
                    .draw();
            }
        }
        var message = '';

        if( route == '/visit/end/bulk') {
            message = 'Selected Visits have been signed out.';
        } else {
            message = 'Selected Visits have been deleted.';
        }

        if(signOutErrorMessage) {
            message = signOutErrorMessage;
            if($('.alert').length) {
                removeAlertClasses();
                $('.alert').addClass('alert-error');
                $('.alert').text(message);
            } else {
                var html = '<div class="alert-container"><div class="alert alert-error">' + message + '</div></div>';
                $('body').append(html);
            }
        } else {
            if($('.alert').length) {
                removeAlertClasses();
                $('.alert').addClass('alert-error');
                $('.alert').text(message);
            } else {
                var html = '<div class="alert-container"><div class="alert alert-success">' + message + '</div></div>';
                $('body').append(html);
            }
        }


        showAlert(endRoute);

    }

    function removeAlertClasses() {
        if($('.alert').hasClass('alert-error')) {
            $('.alert').removeClass('alert-error');
        }
        if($('.alert').hasClass('alert-success')) {
            $('.alert').removeClass('alert-success');
        }
    }

    function doAction(route, ids){


        $.ajax({
            url: window.site.url + route,
            method: 'POST',
            data: {
                ids: ids,
                _token: window.site.token
            },
            success: function( response ) {

                console.log('response: ' + response);
                if(response) {
                    completeCallback(route,ids, response);
                } else {
                    completeCallback(route,ids);
                }

                Modal.closeModal();
                $('.bulk-action').val('null');
                $('.bulk-action-accept').html('Ok');
            },
            complete: function ( response ) {
                // Loop through trs on datatable

                // Remove ids from DOM if in ID list
                // completeCallback(route,ids);


            },
            error: function(jqXHR,textStatus, errorThrown ){

            }
      });
    }

} );


// WEBPACK FOOTER //
// ./filter.js